import React, { useState } from 'react'
import { useDispatch, useStore, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import IntlMessages from '../../util/IntlMessages'
import {
  Card,
  Button,
  Col,
  message,
  Modal,
  Input,
  Avatar,
  Menu,
  Dropdown,
  Radio,
  Breadcrumb,
  Form,
  Row
} from 'antd'
import { PlusCircleOutlined } from '@ant-design/icons'
import {
  loadCurrentSalesOrderStatusData,
  loadCustomerSearchData,
  loadIsDiscardSale,
  loadCurrentSalesOrderData
} from '../../appRedux/actions/Sell'
import {
  loadCurrentSalesOrderStatusID,
  loadFormSellNote,
  loadIsNotesRowVisible
} from '../../appRedux/actions/MainSale'
import {
  isEmptyObject,
  removeSpacewithLowerCaseString,
  getDecryptID
} from '../../appRedux/actions/GlobalMethods'
import SearchCustomer from '../../components/SearchCustomer'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}
const AllStatus = [
  {
    id: 10001,
    value: 'All Sales'
  },
  {
    id: '1&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    value: 'Lay By'
  },
  {
    id: '2&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    value: 'On Account'
  },
  {
    id: '3&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    value: 'Parked'
  },
  {
    id: '4&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    value: 'Delivery, unfulfilled'
  },
  {
    id: '5&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    value: 'Pickup, unfulfilled'
  },
  {
    id: '6&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    value: 'Completed'
  },
  {
    id: '7&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    value: 'Layby, completed'
  },
  {
    id: '8&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    value: 'On Account, completed'
  },
  {
    id: '9&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    value: 'Delivery, completed'
  },
  {
    id: '10&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    value: 'Pickup, completed'
  },
  {
    id: '11&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    value: 'Voided'
  }
]
const FullFillmentOptions = [
  {
    OptionID: 1,
    OptionName: 'sell.sell.moreactions.delivery',
    IsDisabled: false
  },
  {
    OptionID: 2,
    OptionName: 'sell.sell.moreactions.pickup',
    IsDisabled: false
  }
]
const ModalTTypeOptions = [
  {
    OptionID: 1,
    value: 'Method',
    OptionName: 'sell.sell.moreactions.method'
  },
  {
    OptionID: 2,
    value: 'Customer',
    OptionName: 'sell.sell.moreactions.customer'
  },
  {
    OptionID: 3,
    value: 'Full Fillmet Details',
    OptionName: 'sell.sell.moreactions.fullfillmentdetails'
  }
]

const ModalTypeButtons = [
  {
    OptionID: 1,
    formName: 'Method',
    ButtonName1: 'sell.sell.moreactions.dontmark',
    ButtonName2: 'sell.sell.moreactions.next',
    IsDisabledB2: false //its button 2
  },
  {
    OptionID: 2,
    formName: 'Customer',
    ButtonName1: 'sell.sell.moreactions.back',
    ButtonName2: 'sell.sell.moreactions.next',
    IsDisabledB2: true //its button 2
  },
  {
    OptionID: 3,
    formName: 'Full Fillmet Details',
    ButtonName1: 'sell.sell.moreactions.back',
    ButtonName2: 'sell.sell.moreactions.mark',
    IsDisabledB2: false //its button 2
  }
]

const ModalTypeContent = [
  {
    OptionID: 1,
    formName: 'Method',
    Heading: 'sell.sell.moreactions.choosehowthis',
    Description: 'sell.sell.moreactions.inventorywillbe'
  },
  {
    OptionID: 2,
    formName: 'Customer',
    Heading: 'sell.sell.moreactions.contactinfofor',
    Description: 'sell.sell.moreactions.enterdetailsto'
  },
  {
    OptionID: 3,
    formName: 'Full Fillmet Details',
    Heading: 'sell.sell.moreactions.addpickupdetails',
    Description: 'sell.sell.moreactions.recordthepickup'
  }
]

const MoreActionsOptions = [
  {
    OptionID: '1',
    OptionName: 'sell.sell.markasunfullfilled',
    IsDisabled: true
  },
  {
    OptionID: '2',
    OptionName: 'sell.sell.discardsale',
    IsDisabled: true
  }
]

const MoreActions = props => {
  const { isDisabled } = props
  const dispatch = useDispatch()
  const history = useHistory()
  const [form] = Form.useForm()

  const getCustomerObj = useSelector(({ MainSale }) => MainSale.getCustomerObj)
  const getIsRefundSale = useSelector(
    ({ MainSale }) => MainSale.getIsRefundSale
  )
  const getCurrentSalesOrderData = useSelector(
    ({ Sell }) => Sell.currentSalesOrderData
  )
  const getCurrentSalesOrderStatusID = useSelector(
    ({ MainSale }) => MainSale.getCurrentSalesOrderStatusID
  )

  const [getFullFillmentVisible, setFullFillmentVisible] = React.useState(false)
  const [getMoreActionsOptions, setMoreActionsOptions] = React.useState([])
  const [getFullFillmentOptions, setFullFillmentOptions] = React.useState([])
  const [getCurrentModalType, setCurrentModalType] = React.useState(1)
  const [getModalTypeOptions, setModalTypeOptions] = React.useState([])
  const [getModelTypeButtons, setModelTypeButtons] = React.useState([])
  const [getModelTypeContent, setModelTypeContent] = React.useState([])
  const [getCurrentSaleStatusData, setCurrentSaleStatusData] = React.useState(
    {}
  )
  const [getSalesOrderStatuses, setSalesOrderStatuses] = useState([])
  const [getFullFillmentStatusID, setFullFillmentStatusID] = useState(1)

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      checkMoreActionAbility()
      setFullFillmentOptions(FullFillmentOptions)
      setModalTypeOptions(ModalTTypeOptions)
      setModelTypeButtons(ModalTypeButtons)
      setModelTypeContent(ModalTypeContent)
      setSalesOrderStatuses(AllStatus)
      let currentSaleStatus = {
        StatusID: '4&&_9efa-1ea9-4faf-88ed-a48e65b46643',
        StatusName: 'Delivery, unfulfilled'
      }
      setCurrentSaleStatusData(currentSaleStatus)
    }
    return () => (mounted = false)
  }, [])

  React.useEffect(() => {
    let mounted = true
    if (mounted && !isEmptyObject(getCurrentSalesOrderData)) {
      checkMoreActionAbility()
    }

    return () => (mounted = false)
  }, [getCurrentSalesOrderData])

  function checkMoreActionAbility () {
    let selectedSaleOrderData = {}
    selectedSaleOrderData = getCurrentSalesOrderData
    const prods =
      selectedSaleOrderData.products &&
      selectedSaleOrderData.products.length > 0
        ? selectedSaleOrderData.products
        : selectedSaleOrderData.Products
    if (prods != undefined && !isEmptyObject(prods) && prods.length > 0) {
      let moreActions = MoreActionsOptions
      let tempMoreActions =
        moreActions &&
        moreActions.map(e => {
          return {
            OptionID: e.OptionID,
            OptionName: e.OptionName,
            IsDisabled:
              e.OptionID == '1' &&
              (getIsRefundSale ||
                getDecryptID(getCurrentSalesOrderStatusID) == '1' ||
                getDecryptID(getCurrentSalesOrderStatusID) == '2')
                ? true
                : false
          }
        })
      setMoreActionsOptions(tempMoreActions)
    } else {
      setMoreActionsOptions(MoreActionsOptions)
    }
  }

  const handleClickMoreOptions = optionID => {
    //OptionID = 1 = Mark as Unfullfilled, OptionID = 2 = Discard Sale,
    if (optionID == 1) {
      setFullFillmentVisible(true)
    }
    if (optionID == 2) {
      dispatch(loadIsDiscardSale(true))
    }
  }

  const handleFullFillmentDetailsModalVisibility = isVisible => {
    setCurrentModalType(1)
    setFullFillmentVisible(isVisible)
  }

  const handleClickModalType = modalType => {
    if (modalType == 2) {
      setCurrentModalType(modalType)
    } else if (modalType == 3) {
      if (getCustomerObj && !isEmptyObject(getCustomerObj)) {
        setCurrentModalType(modalType)
      } else {
        message.error('Please select customer')
      }
    } else if (modalType == 4) {
      let temp = getCurrentSaleStatusData
      temp.SellNote = form.getFieldValue('SellNote')
      let moreActions = [...getMoreActionsOptions]
      let tempMoreActions =
        moreActions &&
        moreActions.map(e => {
          return {
            OptionID: e.OptionID,
            OptionName: e.OptionName,
            IsDisabled: e.OptionID == 1 ? true : false
          }
        })
      setMoreActionsOptions(tempMoreActions)
      setFullFillmentVisible(false)
      setCurrentModalType(1)
      dispatch(loadCurrentSalesOrderStatusData(temp))
      markFulfilled(temp)
    }
  }

  const handleClickFullfillmentStatus = optionID => {
    setFullFillmentStatusID(optionID)
    let currentSaleStatusData = {}
    if (optionID == 1) {
      let statusID = getSalesOrderStatuses
        .filter(
          x =>
            removeSpacewithLowerCaseString(x.value) ==
            removeSpacewithLowerCaseString('Delivery, unfulfilled')
        )
        .map(e => {
          return e.id
        })
      currentSaleStatusData = {
        StatusID: statusID[0],
        StatusName: 'Delivery, unfulfilled',
        SellNote: ''
      }
    } else if (optionID == 2) {
      let statusID = getSalesOrderStatuses
        .filter(
          x =>
            removeSpacewithLowerCaseString(x.value) ==
            removeSpacewithLowerCaseString(' Pickup, unfulfilled')
        )
        .map(e => {
          return e.id
        })
      currentSaleStatusData = {
        StatusID: statusID[0],
        StatusName: 'Pickup, unfulfilled',
        SellNote: ''
      }
    }
    setCurrentSaleStatusData(currentSaleStatusData)
  }

  const handleCustomerDelete = () => {
    // setCustomerObj({});
    dispatch(loadCustomerSearchData({}))
    // let getButtons = getModelTypeButtons;
    // let updatedButtonValue = getButtons.filter((x) => x.OptionID == 2);
    // if (updatedButtonValue != undefined && updatedButtonValue[0] != undefined) {
    //   updatedButtonValue[0].IsDisabledB2 = true;
    // }
  }

  function markFulfilled (data) {
    let val = data
    let salesOrderData = getCurrentSalesOrderData
    if (val.SellNote != '') {
      salesOrderData.Notes = val.SellNote
      dispatch(loadFormSellNote(val.SellNote))
      // dispatch(loadIsNotesRowVisible(true));
    }
    if (val.StatusID != '') {
      dispatch(loadCurrentSalesOrderStatusID(val.StatusID))
      salesOrderData.E_SalesOrderStatusID = val.StatusID
    }
    dispatch(loadCurrentSalesOrderData(salesOrderData))
  }

  const MoreActionOptions = (
    <Menu>
      {getMoreActionsOptions.map((e, index) => {
        return (
          <Menu.Item
            disabled={e.IsDisabled}
            key={index}
            onClick={() => handleClickMoreOptions(e.OptionID)}
          >
            <IntlMessages id={`${e.OptionName}`} />
          </Menu.Item>
        )
      })}
    </Menu>
  )

  const MethodContent = () => {
    return (
      <>
        <p className='custom-fontheader-size mt-3 mb-2'>
          <IntlMessages id='sell.sell.moreactions.fullfillment' />
        </p>
        <Form form={form} layout='vertical' name='MoreActionFrom'>
          <Row>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <Col span={24} className='custom-pd-left-right'>
                <Radio.Group
                  defaultValue={getFullFillmentStatusID}
                  optionType='button'
                  size='large'
                >
                  {getFullFillmentOptions.map((e, index) => {
                    return (
                      <Radio.Button
                        onClick={() => {
                          handleClickFullfillmentStatus(e.OptionID)
                        }}
                        key={index}
                        value={e.OptionID}
                      >
                        <span>
                          <IntlMessages id={`${e.OptionName}`} />
                        </span>
                      </Radio.Button>
                    )
                  })}
                </Radio.Group>
              </Col>
            </div>
          </Row>
        </Form>
      </>
    )
  }

  const CustomerContent = () => {
    return (
      <>
        <p className='custom-fontheader-size mt-3 mb-2'>
          {' '}
          <IntlMessages id='sell.sell.moreactions.customer' />{' '}
        </p>
        <Form
          {...formItemLayout}
          form={form}
          scrollToFirstError
          id='MoreActionFrom'
          name='MoreActionFrom'
          className='custom-bg-white pos-screen'
        >
          {getCustomerObj && getCustomerObj.customerCode ? (
            <>
              <Card
                className='sell-customer-account-card'
                title={
                  <div className='gx-module-list-icon'>
                    <Row gutter={12}>
                      <Col>
                        <div className='gx'>
                          <Avatar
                            style={{ fontWeight: 'bold' }}
                            className={`gx-avatar gx-bg-${
                              true == 'even' ? 'green' : 'blue'
                            } gx-size-46 mr-10`}
                          >
                            {getCustomerObj.letterName
                              ? getCustomerObj.letterName
                              : '00'}
                          </Avatar>
                        </div>
                      </Col>

                      <Col>
                        <div className='gx-module-list-content'>
                          <div className='gx-mail-user-des'>
                            <span className='gx-sender-name'>
                              {getCustomerObj.customerFirstName
                                ? getCustomerObj.customerFirstName
                                : '-Name-'}
                              {getCustomerObj.customerLastName
                                ? getCustomerObj.customerLastName
                                : ' '}
                            </span>

                            <span className='gx-toolbar-separator'>&nbsp;</span>

                            <span className='vd-flag sm:hidden'>
                              {getCustomerObj.groupName
                                ? getCustomerObj.groupName
                                : 'All Customers'}
                            </span>
                          </div>
                          <div className='gx-message'>
                            <p className='gx-text-truncate'>
                              {getCustomerObj.customerCode
                                ? getCustomerObj.customerCode
                                : '000-ABC'}
                            </p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                }
                extra={
                  <div className='del-btn-div'>
                    <a
                      onClick={() => handleCustomerDelete()}
                      className='trash-icon-btn'
                    >
                      {' '}
                      <i className='icon icon-trash' />{' '}
                    </a>
                  </div>
                }
              ></Card>
            </>
          ) : (
            <>
              <SearchCustomer screen='SellScreen' />
            </>
          )}
        </Form>
      </>
    )
  }

  const FinalContent = () => {
    return (
      <>
        <p className='custom-fontheader-size mt-3 mb-2'>
          <IntlMessages id='sell.sell.moreactions.customer' />
        </p>
        <Form
          {...formItemLayout}
          form={form}
          scrollToFirstError
          id='MoreActionFrom'
          name='MoreActionFrom'
          className='custom-bg-white fullfillment-note'
        >
          {/* We need to add Customer Component */}

          {getCustomerObj && getCustomerObj.customerCode ? (
            <>
              <Card
                className='sell-customer-account-card'
                title={
                  <div className='gx-module-list-icon'>
                    <Row gutter={12}>
                      <Col>
                        <div className='gx'>
                          <Avatar
                            style={{ fontWeight: 'bold' }}
                            className={`gx-avatar gx-bg-${
                              true == 'even' ? 'green' : 'blue'
                            } gx-size-46 mr-10`}
                          >
                            {getCustomerObj.letterName
                              ? getCustomerObj.letterName
                              : '00'}
                          </Avatar>
                        </div>
                      </Col>

                      <Col>
                        <div className='gx-module-list-content'>
                          <div className='gx-mail-user-des'>
                            <span className='gx-sender-name'>
                              {getCustomerObj.customerFirstName
                                ? getCustomerObj.customerFirstName
                                : '-Name-'}
                              {getCustomerObj.customerLastName
                                ? getCustomerObj.customerLastName
                                : ' '}
                            </span>

                            <span className='gx-toolbar-separator'>&nbsp;</span>

                            <span className='vd-flag sm:hidden'>
                              {getCustomerObj.groupName
                                ? getCustomerObj.groupName
                                : 'All Customers'}
                            </span>
                          </div>
                          <div className='gx-message'>
                            <p className='gx-text-truncate'>
                              {getCustomerObj.customerCode
                                ? getCustomerObj.customerCode
                                : '000-ABC'}
                            </p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                }
              ></Card>
            </>
          ) : (
            <>{''}</>
          )}
          <div className='dk-mt-24'>
            <p className='custom-fontheader-size dk-mr-8 dk-mb-3'>
              <IntlMessages id='sell.sell.moreactions.sellnote' />
            </p>
            {/* <p>
              <IntlMessages id="sell.sell.moreactions.customerwillbeable" />
            </p> */}
          </div>
          <Form.Item name='SellNote'>
            <Input.TextArea
              showCount
              placeholder='Enter  a note about this sale'
              maxLength={2000}
              autoSize={{ minRows: 8, maxRows: 10 }}
            />
          </Form.Item>
        </Form>
      </>
    )
  }

  const FullFillmentModal = props => {
    return (
      <Modal
        transitionName=''
        maskTransitionName=''
        title={
          <div>
            <Breadcrumb separator='>'>
              {getModalTypeOptions &&
                getModalTypeOptions.map((e, key) => {
                  return (
                    <Breadcrumb.Item
                      key={key}
                      className={
                        e.OptionID == getCurrentModalType
                          ? 'custom-breadcrumb-color custom-active-breadcrumb'
                          : 'custom-breadcrumb-color'
                      }
                    >
                      <IntlMessages id={`${e.OptionName}`} key={e.OptionID} />
                    </Breadcrumb.Item>
                  )
                })}
            </Breadcrumb>
          </div>
        }
        className='fullfillment-modal'
        visible={getFullFillmentVisible}
        okText={<IntlMessages id='common.resource.save' />}
        onCancel={() => {
          handleFullFillmentDetailsModalVisibility(false)
        }}
        width={400}
        centered={true}
        footer={
          getModelTypeButtons &&
          getModelTypeButtons
            .filter(x => x.OptionID == getCurrentModalType)
            .map((e, index) => {
              return (
                <div key={index}>
                  <Button
                    type='primary'
                    className='dk-btn-cancel'
                    onClick={() => {
                      if (e.OptionID == 1) {
                        handleFullFillmentDetailsModalVisibility(false)
                      } else {
                        handleClickModalType(e.OptionID - 1)
                        setCurrentModalType(getCurrentModalType - 1)
                      }
                    }}
                  >
                    <IntlMessages id={e.ButtonName1} />
                  </Button>

                  <Button
                    type='primary'
                    // className="custom-promoadd-savbtn"
                    className=''
                    // disabled={e.IsDisabledB2}
                    disabled={e.OptionID == 2 && isEmptyObject(getCustomerObj)}
                    onClick={() => handleClickModalType(e.OptionID + 1)}
                  >
                    <IntlMessages id={e.ButtonName2} />
                  </Button>
                </div>
              )
            })
        }
      >
        {getModelTypeContent &&
          getModelTypeContent
            .filter(x => x.OptionID == getCurrentModalType)
            .map((e, key) => {
              return (
                <div key={key}>
                  <h2 className='dk-quick-modal-header'>
                    {' '}
                    <IntlMessages id={e.Heading} />{' '}
                  </h2>
                  <p className=' mb-0'>
                    {' '}
                    <IntlMessages id={e.Description} />{' '}
                  </p>
                </div>
              )
            })}

        {getCurrentModalType == 1 ? (
          <MethodContent />
        ) : getCurrentModalType == 2 ? (
          CustomerContent()
        ) : getCurrentModalType == 3 ? (
          <FinalContent />
        ) : (
          ''
        )}
      </Modal>
    )
  }

  return (
    <>
      {FullFillmentModal()}
      <Dropdown
        overlay={MoreActionOptions}
        placement='bottomLeft'
        disabled={isDisabled}
        trigger='click'
      >
        <Button
          className=''
          icon={<PlusCircleOutlined className='dk-btn-icon-align' />}
        >
          <IntlMessages id='sell.sell.more' />
          <span className='dk-text-hide-on-mobile'>
            <IntlMessages id='sell.sell.actions' />
          </span>
        </Button>
      </Dropdown>
    </>
  )
}

export default MoreActions
